'use strict';

/**
 * @author Maxim Seredkin
 */
export default function () {
  return {
    restrict: 'A',
    template: require('../view/project-tab-funds.html'),
    controller: [
      '$scope',
      function ($scope) {
        $scope.getTotal = getTotal;
        $scope.getTotalPlanFundsAmount = getTotalPlanFundsAmount;
        $scope.getTotalFactFundsAmount = getTotalFactFundsAmount;
        $scope.getPercentage = getPercentage;
        $scope.getMunicipalBudget = getMunicipalBudget;
        $scope.getFederalBudget = getFederalBudget;
        $scope.getLocalBudget = getLocalBudget;
        $scope.getOffBudget = getOffBudget;
        $scope.getOwnBudget = getOwnBudget;
        $scope.getInvestorBudget = getInvestorBudget;
        $scope.getRestFund = getRestFund;
        $scope.chartOptions = {
          cutoutPercentage: 70,
          aspectRatio: 1,
          borderWidth: 0,
          animation: false,
          plugins: {
            labels: {
              render: 'percentage',
              showZero: false,
              fontStyle: 'bold',
              position: 'center',
              precision: 1,
              fontColor: '#333',
            },
            radiusBackground: {
              color: '#dcdcdc',
              enabled: true,
            },
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                const { datasets, labels } = data;
                const { index, datasetIndex } = tooltipItem;
                if (!labels[index]) return tooltipItem;
                const labelParts = labels[index].split(',');
                if (!datasets[datasetIndex] || !datasets[datasetIndex].data)
                  return tooltipItem;
                return `${labelParts[0]}: ${datasets[datasetIndex].data[index]} ${labelParts[1]}`;
              },
            },
          },
        };

        function getPercentage() {
          const total = getTotal();
          if (total === 0) return 0;
          return Math.min(
            Math.round((getTotalPlanFundsAmount() * 100) / total),
            100
          );
        }
        function getRestFund() {
          return Math.max(getTotal() - getTotalPlanFundsAmount(), 0);
        }
        function getTotal() {
          return $scope.project.planFundsTotal
            ? $scope.project.planFundsTotal
            : 0;
        }
        function getMunicipalBudget() {
          return (
            Math.round(
              ($scope.project.projectPlanFundsByYear || []).reduce(
                (acc, value) => acc + (value.municipalBudget || 0),
                0
              ) * 100
            ) / 100
          );
        }
        function getFederalBudget() {
          return (
            Math.round(
              ($scope.project.projectPlanFundsByYear || []).reduce(
                (acc, value) => acc + (value.federalBudget || 0),
                0
              ) * 100
            ) / 100
          );
        }
        function getLocalBudget() {
          return (
            Math.round(
              ($scope.project.projectPlanFundsByYear || []).reduce(
                (acc, value) => acc + (value.localBudget || 0),
                0
              ) * 100
            ) / 100
          );
        }
        function getOffBudget() {
          return (
            Math.round(
              ($scope.project.projectPlanFundsByYear || []).reduce(
                (acc, value) => acc + (value.offBudget || 0),
                0
              ) * 100
            ) / 100
          );
        }
        function getOwnBudget() {
          return (
            Math.round(
              ($scope.project.projectPlanFundsByYear || []).reduce(
                (acc, value) => acc + (value.ownBudget || 0),
                0
              ) * 100
            ) / 100
          );
        }
        function getInvestorBudget() {
          return (
            Math.round(
              ($scope.project.projectPlanFundsByYear || []).reduce(
                (acc, value) => acc + (value.investorBudget || 0),
                0
              ) * 100
            ) / 100
          );
        }
        function getTotalPlanFundsAmount() {
          return (
            getMunicipalBudget() +
            getFederalBudget() +
            getLocalBudget() +
            getOffBudget()
          );
        }

        function getTotalFactFundsAmount() {
          return (
            Math.round(
              ($scope.project.projectFactFunds || []).reduce(
                (acc, value) => acc + (value.amount || 0),
                0
              ) * 100
            ) / 100
          );
        }
      },
    ],
  };
}
